module.exports = __webpack_public_path__ + "img/6.33e41d35.png";